import { ISearchPage } from "@/types/AppTypes";

//详情
export interface IShipmentDetail {
    "id"?: string,    // "外贸合同id",
    "code": string,    // "出口出运单号",
    "offerCode"?: string,    // "报价单号",
    "shopCode"?: string,    // "门店编码",
    "shopName"?: string,    // "门户名称",
    "customerId"?: string,    // "客户id",
    "customerCode"?: string,    // "客户编号",
    "customerName"?: string,    // "客户名称",
    "contact"?: string,    // "客户联系人",
    "phone"?: string,    // "客户联系电话",
    "customerTypeCode"?: string,    // "客户类型",
    "customerTypeName"?: string,    // "客户类型名称 ",
    "currency"?: string,    // "币种",
    "typeNum"?: string | number,    // "发票类型",
    "country"?: string,    // "贸易国别",
    "status"?: string,    // "状态",
    "offerTime"?: moment.Moment | null | string,    // "报价日期",
    "termTime"?: moment.Moment | null | string,    // "有效日期",
    "rmbAmount"?: string,    // "人民币金额",
    "goodsAmount": string | number,    // "货值金额",
    "addAmount": string | number,    // "附加费",
    "contractAmount": string | number,    // "合同总金额",
    "exchangeRate": string | number,    // "汇率",
    "discount"?: string,    // "整体上浮",
    "clause"?: string,    // "价格条款",
    "transportMode"?: string,    // "运输方式",
    "destination"?: string,    // "目的地",
    "shipment"?: string,    // "装货港",
    "discharge"?: string,    // "卸货港",
    "agentCompany"?: string,    // "代货公司",
    "shippingMark"?: string,    // "唛头",
    "advise"?: string,    // "审批意见",
    "adviseOne"?: string,    // "审批意见1",
    "deliveryTime"?: string,    // "出库日期",
    "shippingTime"?: string,    // "发运日期",
    "settlementTime"?: string,    // "结算日期",
    "payTime"?: string,    // "结款日期",
    "reckoner"?: string,    // "财务",
    "insure"?: string,    // "保险",
    "bentityCode"?: string,    // "实体编码",
    "bentityName"?: string,    // "实体名称",
    "note"?: string,    // "备注",
    batches?: string// "分批",
    transship?: string // "转船",
    "totalTxt"?: string,    // "备注",
    "currencyName"?: string,    // "备注",
    "currencyCode"?: string,    // "备注",
    details?: IShipmentMaterial[];
    detailsAdd?: IShipmentDetailsAdded[];
    detailsPayment?: IShipmentDetailMethod[];
    detailsContainer?: IShipmentBoxInfo[];
    'updateTime'?: moment.Moment | null | string,
    'createTime'?:moment.Moment | null | string,

}

export interface IShipmentMaterial {
    netWeight?: string | number;
    grossWeight?: string | number;
    key: string,
    "id"?: string,    // "外贸合同明细id",
    "shipmentId"?: string,    // "出口出运单id",
    "shipmentCode"?: string,    // "出口出运单Code",
    "materialId"?: string,    // "物料id",
    "materialCode"?: string,    // "物料编号",
    "materialName"?: string,    // "物料名称",
    "materialEname"?: string,    // "物料名称英文",
    "replaceCode"?: string,    // "替换号",
    "typeCode"?: string,    // "物料类型",
    "typeName"?: string,    // "物料类型名称",
    "model"?: string,    // "规格",
    "salePrice"?: string | number,    // "云湖销售单价(人民币)",
    "saleAmount"?: string | number,    // "云湖销售总额(人民币)",
    "num": string | number,    // "询价数量",
    "price"?: string | number,    // "外卖单价",
    "amount": string | number,    // "外卖总价",
    "customsCode"?: string,    // "海关商品编码",
    "note"?: string,    // "备注"
    "totalTxt"?: string,    // "备注"
}

//编辑
export interface IShipmentUpdate {
    id: string,
}

//搜索条件
export interface IShipmentSearchFields {
    "customerName"?: string,    // "客户名称",
    "saleCode"?: string,    // "外贸合同",
    "code"?: string,    // "单据编号",
    "status"?: string,    // "单据状态",
    "satrtTime"?: string,    // "开始时间",
    "endTime"?: string,    // "结束时间",
}

export interface IShipmentSearch
    extends IShipmentSearchFields, ISearchPage {
    [key: string]: any
}


//加收费用
export interface IShipmentDetailsAdded {
    key: string;
    amount: string | number; //      50
    currencyAmount?: string | number; //      50
    code?: string; //    "询-999-21121400001"
    createTime?: string; //          "2021-12-14T20?:string,
    createUser?: string; //          null
    currencyCode?: string; //            "币种"
    currencyName?: string; //            "币种"
    deleteFlag?: string; //          0
    ename?: string; //     "加收英文"
    id?: string; //  "1"
    supplierName?: string; //    "加收费用"
    supplierCode?: string; //    "加收费用"
    filename?: string; //    "加收费用"
    md5?: string; //    "加收费用"
    name?: string; //    "加收费用"
    status?: string; //    "加收费用"
    orderNum?: string; //        0
    updateTime?: string; //          "2021-12-14T20?:string,
    updateUser?: string; //         // null
}


//加收方式结算

export interface IShipmentAddedSettle {
    visible: boolean,
    addedRow: IShipmentDetailsAdded | null
}

//收汇方式
export interface IShipmentDetailMethod {
    key: string;
    amount?: string | number; // 65
    around?: string; // "或前"
    certificatesTime?: moment.Moment | null | string; // "预计收证日期"
    code?: string; // "询-999-21121400001"
    collectionTime?: moment.Moment | null | string; // "预计收款日期"
    createTime?: string; // "2021-12-14T20:45:38"
    createUser?: string; // null
    deleteFlag?: string; // 0
    id?: string; // "1"
    orderNum?: string; // 0
    paymentMethod?: string; // "收汇方式"
    paymentTime?: moment.Moment | null | string; // "日期"
    proportion?: string; // "比例"
    updateTime?: string; // "2021-12-14T20:46:29"
    updateUser?: string; // null
}

/**
 * 详情s
 */
//tab枚举
export enum IShipmentTabEnum {
    BASE_DETAIL = "base_detail",  //基本信息
    MATERIAL_INFO = "material_info", //商品信息
    FILES = "files",   //附件管理
    LOGISTICS_PROCESS = "logistics_process", //物流进程
    BOX_INFO = "box_info" //装箱信息
}


/**
 * 物流进程
 */
export interface ILogistics {
    "id"?: string,    // "beff44853a9fbe54f4852fd121e2af68",
    "shipmentCode"?: string,    // "9987",
    "testTime"?: moment.Moment | null | string,    // "商检日期",
    "consignmentTime"?: moment.Moment | null | string,    // "托运日期11",
    "etd"?: moment.Moment | null | string,    // "ETD1",
    "eta"?: moment.Moment | null | string,    // "ETA1",
    "carryTime"?: moment.Moment | null | string,    // "装柜完成日期1",
    "releaseTime"?: moment.Moment | null | string,    // "海关放行日期1",
    "reportCode"?: string,    // "报告单号",
    "shipmentTime"?: moment.Moment | null | string,    // "实际装船日期",
    "ladingNum"?: string,    // "提单号",
    "ladingTime"?: moment.Moment | null | string,    // "提单日期",
    "flight"?: string,    // "航次航名 ",
    "backTime"?: moment.Moment | null | string,    // "收回日期",
    "presentationTime"?: moment.Moment | null | string,    // "交单日期",
    "presentationType"?: string,    // "交单类型",
    "certificatesTime"?: moment.Moment | null | string,    // "预计收汇日期",
    "bank"?: string,    // "交单银行",
    "clearTime"?: moment.Moment | null | string,    // "清关日期",
    "deliveryTime"?: moment.Moment | null | string,    // "入库日期"
    "status"?: string,    // "入库日期"
    /**
    * 托运日期
    */
    bookingTime?: moment.Moment | null | string,

    /**
     * 订舱备注
     */
    consignmentNote?: string,

    /**
     * 装柜备注
     */
    carryNote?: string,

    /**
     * 报关日期
     */
    declareTime?: moment.Moment | null | string,

    /**
     * 报关放行备注
     */
    releaseNote?: string,

    /**
     * 装船备注
     */
    shipmentNote?: string,

    /**
     * 提单备注
     */
    ladingNote?: string,
}

//收汇方式
export interface IShipmentBoxInfo {
    /**
     * 集装箱号
     */
    containerCode?: string,  //

    /**
     * 铅封号
     */
    sealNum?: string,  //

    /**
     * 司机
     */
    driver?: string,  //

    /**
     * 联系电话
     */
    phone?: string,  //

    /**
     * 车牌号
     */
    licensePlate?: string,  //

    /**
     * 日期
     */
    date?: moment.Moment | null | string,   //

    /**
     * 备注
     */
    note?: string,  //、
    [key: string]: any
}